import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {SERVER_API_URL} from 'src/app/app.constants';
import {IUser} from 'src/app/core/user/user.model';
import {IClientDTO} from 'src/app/shared/model/client.model';
import {createRequestOption} from 'src/app/shared/util/request-util';

type EntityResponseType = HttpResponse<IClientDTO>;
type EntityArrayResponseType = HttpResponse<IClientDTO[]>;

@Injectable({ providedIn: 'root' })
export class ClientService {

    private resourceUrl = SERVER_API_URL + 'api/users/client';
    private spotClientResourceUrl = SERVER_API_URL + 'api/users/spot-client';

    private reviseResourceUrl = SERVER_API_URL + 'api/users/client-certificate';

    private policyCurrencyResourceUrl = SERVER_API_URL + 'api/policyCurrency';

    private resourceUrlGetCertificate = SERVER_API_URL + 'api/users/client/getBrokerCertificate';
    private resourceUrlGetDeclaration = SERVER_API_URL + 'api/users/client/getBrokerDeclaration';
    private brokerUserData = SERVER_API_URL + 'api/broker/internal-staffs';
    private userMailUrl = SERVER_API_URL + 'api/users/emailAuthentication';
    private resourceUrlForClientIS = SERVER_API_URL + 'api/users/client/internal-staff';
    private resourceUrlForClientISGroup = SERVER_API_URL + 'api/users/client/internal-staff-groups';


    constructor(private http: HttpClient) {}

    findPolicyCurrencyDetails(id:number): Observable<any> {
            return this.http
            .get<any>(`${this.policyCurrencyResourceUrl}/${id}`, { observe: 'response' })
            .map((res: any) => res);
    }

    findPolicyIdAndCurrencyDetails(id:number,policyId?:number): Observable<any> {

        let url=`${this.policyCurrencyResourceUrl+'-policy'}/${id}`;
        if(policyId!=null) {
            url+='/'+policyId
        }

        return this.http
            .get<any>(url, { observe: 'response' })
            .map((res: any) => res);
    }


    create(internalStaff: IClientDTO): Observable<EntityResponseType> {
        // const copy = this.convertDateFromClient(internalStaff);
        return this.http
            .post<IClientDTO>(this.resourceUrl, internalStaff, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    createSpotClient(internalStaff: IClientDTO): Observable<EntityResponseType> {
        // const copy = this.convertDateFromClient(internalStaff);
        return this.http
            .post<IClientDTO>(this.spotClientResourceUrl, internalStaff, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    update(internalStaff: IClientDTO): Observable<EntityResponseType> {
        // const copy = this.convertDateFromClient(internalStaff);
        return this.http
            .put<IClientDTO>(this.resourceUrl, internalStaff, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }



    find(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IClientDTO>(`${this.resourceUrl}/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }


    findCertificateClient(id: number): Observable<EntityResponseType> {
        let url=`${this.reviseResourceUrl}/${id}/`;
        return this.http
            .get<IClientDTO>(url, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    view(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IClientDTO>(`${this.resourceUrl}/view/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    private convertDateFromClient(tax: IClientDTO): IClientDTO {
        const copy: IClientDTO = Object.assign({}, tax, {
            // effectiveFromDate: tax.effectiveFromDate != null && tax.effectiveFromDate.isValid() ? tax.effectiveFromDate.toJSON() : null,
            // effectiveEndDate: tax.effectiveEndDate != null && tax.effectiveEndDate.isValid() ? tax.effectiveEndDate.toJSON() : null
        });
        return copy;
    }

    private convertDateFromServer(res: EntityResponseType): EntityResponseType {
        // res.body.effectiveFromDate = res.body.effectiveFromDate != null ? moment(res.body.effectiveFromDate) : null;
        // res.body.effectiveEndDate = res.body.effectiveEndDate != null ? moment(res.body.effectiveEndDate) : null;
        return res;
    }

    private convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
        // res.body.forEach((tax: IInternalStaff) => {
        //     // tax.effectiveFromDate = tax.effectiveFromDate != null ? moment(tax.effectiveFromDate) : null;
        //     // tax.effectiveEndDate = tax.effectiveEndDate != null ? moment(tax.effectiveEndDate) : null;
        // });
        return res;
    }

    queryWithConveyance(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IClientDTO[]>(`${this.resourceUrl}/info`, { params: options, observe: 'response' })
            .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));
    }
    queryWithSpotClient(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IClientDTO[]>(`${this.spotClientResourceUrl}/info`, { params: options, observe: 'response' })
            .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));
    }

    queryOpenClients(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IClientDTO[]>(`${SERVER_API_URL}api/users/open-client/info`, { params: options, observe: 'response' })
            .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));
    }
    getBrokerCertificate(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IClientDTO[]>(this.resourceUrlGetCertificate, { params: options, observe: 'response' })
            .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));
    }

    getBrokerDeclaration(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IClientDTO[]>(this.resourceUrlGetDeclaration, { params: options, observe: 'response' })
            .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));
    }

    query(): Observable<EntityArrayResponseType> {
        return this.http.get<IUser[]>(this.brokerUserData + '?manager=client', { observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
    active(id: number): Observable<HttpResponse<any>> {
        return this.http.put<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    verifyEmail(mail: string) {
        return this.http.post<IClientDTO>(this.userMailUrl, mail);
    }

    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<IClientDTO>(`${this.resourceUrl}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }

    getByUrl(url?: any): Observable<any> {
        return this.http.get<any>(SERVER_API_URL  + url, { observe: 'response' });
    }

    // getClientAddress(id: any): Observable<any> {
    //     const addressURL = SERVER_API_URL + 'api/certificate/get-client-Details/'+id;
    //     return this.http.get<any[]>(addressURL, { observe: 'response' });
    // }

    accessPlatform(id: number): Observable<HttpResponse<any>> {
        return this.http.get<any>(`${this.resourceUrl}/access-platform/${id}`, { observe: 'response' });
    }
    getDataInternalStaff(id:number): Observable<any>{
        return this.http.get<any>(SERVER_API_URL + 'api/users/client/internal-staff/' + id, { observe: 'response' });
     }


     deleteInternalStaffForClient( id: number): Observable<HttpResponse<any>>{
        return this.http.delete<any>(`${this.resourceUrlForClientIS}/${id}`, { observe: 'response' });
    }

    deleteInternalStaffGroupForClient( id: number): Observable<HttpResponse<any>>{
        return this.http.delete<any>(`${this.resourceUrlForClientISGroup}/${id}`, { observe: 'response' });
    }

    changeStatusInternalStaffForClient( id: number): Observable<HttpResponse<any>>{
        return this.http.put<any>(`${this.resourceUrlForClientISGroup}/change-status/${id}`, { observe: 'response' });
    }

    reScreenClient(data: any) {
        return this.http.post<any>(SERVER_API_URL + 'api/finscan/rescreen-entity', data, { observe: 'response' })
    }

    getReferredByUsers() {
        return this.http.get(SERVER_API_URL+'api/users/get-referred-by-users',{observe: 'response'});
    }

    getAdminUser(id:number){
        return this.http.get<any>(SERVER_API_URL + 'api/users/client/admin-user/' + id, { observe: 'response' });
    }

    makeStaffAsAdmin(clientId:number,staffId:number){
        return this.http.get<any>(SERVER_API_URL + 'api/make-internal-staff-admin/'+clientId + '/' +staffId, { observe: 'response' });
    }

    makeAdminUserAsStaff(clientId:number,staffId:number){
        return this.http.get<any>(SERVER_API_URL + 'api/remove-internal-staff-admin/'+clientId + '/' +staffId, { observe: 'response' });
    }

}
